import { ComponentStyleConfig } from "@chakra-ui/react";
import { SystemStyleObject } from "@chakra-ui/styled-system";
import { mergeWith } from "lodash-es";
import { activeFontWeightWithConsistentWidth } from "shared/utils/StyleUtils";

const tabColors: Record<string, SystemStyleObject> = {
  green: {
    textColor: "primary.600",
    borderBottomColor: "primary.300",
  },
  gray: {
    textColor: "gray.700",
    borderBottomColor: "gray.400",
  },
};

const TabsTheme: ComponentStyleConfig = {
  baseStyle: {
    tab: {
      textDecoration: "none",
      _hover: {
        textDecoration: "none",
      },
    },
    tabpanel: {
      px: 0,
    },
  },
  variants: {
    table: {
      root: {
        display: "contents",
      },
      tabpanels: {
        display: "contents",
      },
      tabpanel: {
        display: "contents",
      },
    },
    line: ({ colorScheme }) => {
      const { textColor, borderBottomColor } = tabColors[colorScheme];
      return {
        tablist: {
          minHeight: "30px",
          borderBottom: "1px solid",
        },
        tab: mergeWith(
          {},
          {
            alignItems: "center",
            userSelect: "none",
            whiteSpace: "nowrap",
            lineHeight: "14px",
            padding: 0,
            paddingTop: "3px",
            marginRight: "24px",
            marginBottom: "-1px",
            borderBottom: "2px solid",
            borderBottomColor: "transparent",
            _active: {
              bg: "none",
              _before: {
                bg: "none",
              },
            },
            _selected: {
              borderBottomColor,
            },
            _disabled: {
              borderBottomColor: "transparent",
            },
            _before: {
              // this is needed because the pseudo-element does not inherit
              // the parent's layout.
              height: "100%",
              alignItems: "center",
              display: "flex",
              whiteSpace: "nowrap",
            },
          },
          activeFontWeightWithConsistentWidth(
            "title",
            "&[aria-selected=true]",
            {
              fontWeight: "normal",
              color: "gray.500",
            },
            {
              fontWeight: "medium",
              textColor,
            },
          ),
        ),
      };
    },
  },
  defaultProps: {
    colorScheme: "green",
  },
};

export default TabsTheme;
